module.exports = __webpack_public_path__ + "img/img-box-2.d6668b19.png";